module.exports = __webpack_public_path__ + "img/logbooks-1-mobile.7c0fcf01.gif";